<div class="flex flex-col gap-y-8">
  <!-- Tab Navigation -->
  <div class="border-b border-gray-200 mb-1">
    <nav class="flex space-x-8" aria-label="Tabs">
      <button
        *ngFor="let tab of tabs"
        (click)="onTabChange(tab.id)"
        [class]="isActiveTab(tab.id)
          ? 'border-primary text-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        {{ tab.name }}
      </button>
    </nav>
  </div>

  <!-- Tab Content -->
  <div class="tab-content">
    <app-email-history *ngIf="isActiveTab('history')"></app-email-history>
    <app-send-email *ngIf="isActiveTab('send')"></app-send-email>
    <app-email-template *ngIf="isActiveTab('templates')"></app-email-template>
  </div>
</div>
